import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import BlogPage from "./pages/BlogPage";
import WebdevelopmentPage from "./pages/WebdevelopmentPage";
import MobileAppDevelopment from "./pages/MobileAppDevelopment";
import UiuxPage from "./pages/UiuxPage";
import ApiDevelopmentPage from "./pages/ApidevelopmentPage";
import ECommerceDevelopmentPage from "./pages/ECommerceDevelopmentPage";
import CrmdevelopmentPage from "./pages/CrmdevelopmentPage";
import CloudsolutionsPage from "./pages/CloudsolutionsPage";
import ZohoservicesPage from "./pages/ZohoservicesPage";
import DevelopmentsupportPage from "./pages/DevelopmentsupportPage";
import WebportfolioPage from "./pages/WebportfolioPage";
import AppportfolioPage from "./pages/AppportfolioPage";
import PortfoliosdetailsPage from "./pages/PortfoliosdetailsPage";
import AppPortfoliosdetailsPage from "./pages/AppPortfoliosdetailsPage";
import TermsAndCondition from "./pages/TermsAndCondition";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import BlogDetailsPage from "./pages/BlogDetailsPage";
import ScrollToTop from "./components/ScrollToTop";
import QuotePopup from "./components/Quote-popup";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <QuotePopup />
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/web-development" element={<WebdevelopmentPage />} />
          <Route
            path="/mobile-app-development"
            element={<MobileAppDevelopment />}
          />
          <Route path="/ui-ux" element={<UiuxPage />} />
          <Route path="/api-development" element={<ApiDevelopmentPage />} />
          <Route
            path="/e-commerce-development"
            element={<ECommerceDevelopmentPage />}
          />
          <Route path="/crm-development" element={<CrmdevelopmentPage />} />
          <Route path="/cloud-solutions" element={<CloudsolutionsPage />} />
          <Route path="/zohoservices" element={<ZohoservicesPage />} />
          <Route
            path="/developmentsupport"
            element={<DevelopmentsupportPage />}
          />
          <Route path="/web-portfolio" element={<WebportfolioPage />} />
          <Route path="/app-portfolio" element={<AppportfolioPage />} />
          <Route
            path="/portfolios-details/:id"
            element={<PortfoliosdetailsPage />}
          />
          <Route
            path="/app-portfolios-details/:id"
            element={<AppPortfoliosdetailsPage />}
          />
          <Route path="/terms-and-condition" element={<TermsAndCondition />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/blog-details/:id" element={<BlogDetailsPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
